module.exports = __webpack_public_path__ + "img/ipad.d4acf22e.png";